import React from 'react'
import { ReactComponent as FullScreenIcon } from './icons/fullscreen.svg'
import { ReactComponent as ExitFullScreenIcon } from './icons/exit-fullscreen.svg'
import useDetectDevice from '../../../../hooks/useDetectDevice'
function FullScreenToggle({ className = '' }) {
  const { isMobile } = useDetectDevice()

  const isInIframe = window.self !== window.top

  function openFullscreen() {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen()
    } else {
      console.error('Fullscreen API is not supported, will try to fallback to redirect ...')
      window.top.location.href = window.location.href
    }
  }

  function exitFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen()
    } else {
      console.error('Fullscreen API is not supported')
    }
  }

  const hasFullScreenSupport =
    document.documentElement.requestFullscreen || document.documentElement.webkitRequestFullscreen

  const [isFullScreen, setIsFullScreen] = React.useState(false)

  React.useEffect(() => {
    function onFullScreenChange() {
      setIsFullScreen(document.fullscreenElement || document.webkitFullscreenElement)
    }

    document.addEventListener('fullscreenchange', onFullScreenChange)

    return () => {
      document.removeEventListener('fullscreenchange', onFullScreenChange)
    }
  }, [])

  const show = isMobile ? isInIframe || hasFullScreenSupport : true

  return (
    show && (
      <button
        onClick={() => {
          isFullScreen ? exitFullscreen() : openFullscreen()
        }}
        type="button"
        className={`h-[32px] w-[32px] bg-[#fff] rounded-[4px] flex items-center justify-center shadow-md relative ${className}`}
      >
        {isFullScreen ? <ExitFullScreenIcon /> : <FullScreenIcon />}
      </button>
    )
  )
}

export default FullScreenToggle
